import React from 'react';
import RefNavbar from './RefNavbar';
import RefWaitingList from './RefWaitingList';

function Page2026WaitingList() {
  return (
    <>
      <RefNavbar />
      <RefWaitingList />
    </>
  );
}

export default Page2026WaitingList;
